//@flow
import NotificationsStore from './notificationsStoreClass';

export default new NotificationsStore();
